import { SESSION_SCOPED_USER_QUERY_KEY } from "@/constants";

/** TanStack Query key for the authenticated session user (`GET /api/users/me`). */
export const CURRENT_USER_QUERY_KEY = [
  "current-user",
  SESSION_SCOPED_USER_QUERY_KEY,
] as const;
